import React from 'react';
import PropTypes from 'prop-types';
import LinkGroupHeading from './styled/LinkGroupHeading';
import { Expand, Minus, Plus } from '../../../common/css_global/mobile/utils.css';
import { Mobile } from '../../MediaQuery';

const LinkGroupTitle = ({ title, s3BasePath, showSection, toggleSection, index }) => (
  <LinkGroupHeading expand={showSection} onClick={() => toggleSection(index)}>
    {title}
    <Mobile>
      <Expand>
        {showSection ? (
          <Minus src={`${s3BasePath}mkt/icon/minus_white.png`} />
        ) : (
          <Plus src={`${s3BasePath}mkt/icon/plus_white.png`} />
        )}
      </Expand>
    </Mobile>
  </LinkGroupHeading>
);

LinkGroupTitle.propTypes = {
  title: PropTypes.string.isRequired,
  s3BasePath: PropTypes.string.isRequired,
  index: PropTypes.number,
  toggleSection: PropTypes.func,
  showSection: PropTypes.bool,
};

export default LinkGroupTitle;
